// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","7879":"d46e186c66a9728c","7986":"f2581f4ce8d9a503","8199":"a278752707f705af","9700":"d5f8a49525530ebf"}[chunkId] + ".css";
};